import { gql } from 'graphql-request'

export const REMOVE_PEN_NAME = gql`
  mutation RemovePenName($deletePenNameInput: DeletePenNameInput!) {
    removePenName(deletePenNameInput: $deletePenNameInput) {
      id
    }
  }
`
